import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { CurrencyInfo } from '@/core/currency/interfaces';
import { formatCurrency } from '@/core/currency/helpers';
import { LoyaltyInfo } from '@/core/payment-card/interfaces';

@Component({
    data() {
        return {
            inputValue: null
        };
    }
})
export default class LoyaltyInput extends Vue {
    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Object)
    loyaltyInfo: LoyaltyInfo;

    @Prop(Number)
    amount: number;

    inputValue: number;

    @Watch('inputValue')
    onChangeSelectedValue(value) {
        this.$emit('input', value);
    }

    get maxRedemptionAmount() {
        return this.amount >= this.loyaltyInfo.availableAmount / 100
            ? this.loyaltyInfo.availableAmount / 100
            : this.amount;
    }

    get minRedemptionAmount() {
        return this.loyaltyInfo.minRedemptionAmount / 100;
    }

    format(value: number, format: string) {
        return formatCurrency(
            value || '0',
            this.currency?.format,
            format
        );
    }
}
